import Model from '../model/model';





export default class AppState {

    constructor() {
        this.clear();
    }

    clear() {
        this.state_ = [[null, {}]];
    }

    restore(stringified) {
        this.state_ = JSON.parse( Base64.decode( stringified ) );
    }

    stringify() {
        const deepcopy = value => {
            if (value instanceof Model)
                return value.id;

            if (value instanceof Array)
                return value.map( deepcopy );

            if (value instanceof Object)
                return Object.keys( value )
                    .map( k => [k, deepcopy( value[k] )] )
                    .reduce( (obj, [k, v]) => (obj[k] = v, obj), {} );
                    
            return value;
        };

        return Base64.encodeURI( JSON.stringify( deepcopy( this.state_ ) ) );
    }

    urlify() {
        let [moduleBaseUrl] = this.getTopState();
        if (!moduleBaseUrl.endsWith( '/' ))
            moduleBaseUrl += '/';
    
        return `${moduleBaseUrl}${this.stringify()}`;
    }

    getTopState() {
        return this.state_[this.state_.length - 1];
    }

    push(moduleUrl, moduleState) {
        this.state_.push( [moduleUrl, moduleState] );
    }

    pop() {
        this.state_.pop();
    }

    replaceTop(moduleUrl, moduleState) {
        this.state_.pop(); 
        this.state_.push( [moduleUrl, moduleState] );
    }

    replace(moduleUrl, moduleState) {
        this.state_ = [[moduleUrl, moduleState]];
    }

    size() {
        return this.state_.length;
    }

}


// WEBPACK FOOTER //
// ./src/js/core/app.state.js